import request from '@/utils/request'

// 查询编码生成配置列表
export function listType (query) {
  return request({
    url: '/system/sysCodeRuleConfig/list',
    method: 'get',
    params: query
  })
}

// 新增编码生成配置
export function addType (data) {
  return request({
    url: '/system/sysCodeRuleConfig',
    method: 'post',
    data: data
  })
}

// 修改编码生成配置
export function updateType (data) {
  return request({
    url: '/system/sysCodeRuleConfig',
    method: 'put',
    data: data
  })
}

// 修改编码生成配置
export function genType (query) {
  return request({
    url: '/system/sysCodeRuleConfig/currentString',
    method: 'get',
    params: query
  })
}

// 删除编码生成配置
export function delType (dictId) {
  return request({
    url: `/system/sysCodeRuleConfig/${dictId}`,
    method: 'delete'
  })
}
